import React, { useState, useRef } from "react";
import axios from "axios";
import { ROOT_URL } from "../../../../config/url";
import {
  getErrorMessageByKey,
  useNotification,
  useObject,
  Input,
  useList,
  Select,
  getAccountFio,
  jsonFormatText,
  isValidateNullText,
  Modal,
} from "@vokymlak/kabinet-ui";

function ModalFileFromFolder(props) {
  const {
    object: [object],
  } = useObject({
    apiUrl: "/api/catalog-entry/" + props.object.uuid,
    rootUrl: ROOT_URL,
    callbackError: () => {
      props.handleClose();
    },
  });

  const { notification } = useNotification();

  const changeEdit = (event) => {
    event.preventDefault();

    axios
      .get("/api/catalog-entry/" + props.object.uuid + "/from-folder", {
        withCredentials: false,
        baseURL: ROOT_URL,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("tokenSession"),
        },
      })
      .then(() => {
        props.successfulRequest();
        notification("Данные сохранены", "green");
        props.handleClose();
      })
      .catch((error) => {
        notification(getErrorMessageByKey(error.response.data.error), "red");
      });
  };

  return (
    !!object && (
      <Modal handleClose={() => props.handleClose()}>
          <form className="Form" onSubmit={(event) => changeEdit(event)}>
            <div className="Form__title">
              {object.title}
              <div className="Text__signature">Вынести из группу</div>
            </div>

            <div className="Form__actions Form__actions_center">
              <button className="Action__button Action__button_all Action__button_gray">
                Вынести
              </button>
            </div>
          </form>
      </Modal>
    )
  );
}

export default ModalFileFromFolder;
